import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import { grey } from "@mui/material/colors";
import NumberTextField from "components/ReusableComponents/NumberTextField";
import { datatypes } from "data/globalData";

const CustomTextField = ({ data, setData, column, width, required, type, sx, disabled, onChange, disableLabel, variant }) => {
	const fieldSx = {
		"& .MuiOutlinedInput-root": {
			minHeight: 40,
			borderRadius: 1.5,
			bgcolor: "grey.50",
			transition: "background-color 0.15s ease, box-shadow 0.15s ease",
			"&:hover": { bgcolor: "common.white" },
			"&.Mui-focused": {
				bgcolor: "common.white",
				boxShadow: "0 0 0 3px rgba(25, 118, 210, 0.12)",
			},
		},
		...(sx || {}),
	};

	return (
		<Stack sx={{ width, minWidth: 0 }} spacing={0.5} minHeight={disableLabel ? "auto" : 72}>
			{!disableLabel && (
				<InputLabel
					sx={{
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
						color: grey[700],
						fontSize: "0.75rem",
						fontWeight: 600,
						letterSpacing: "0.02em",
						textTransform: "uppercase",
					}}>
					{column?.name}
					{required && <span style={{ color: "#d32f2f" }}> *</span>}
				</InputLabel>
			)}
			{column?.data_type === datatypes.NUMBER.key ? (
				<NumberTextField
					size="small"
					fullWidth
					variant={variant ? variant : "standard"}
					sx={fieldSx}
					disableHelperText
					disabled={disabled}
					onChange={onChange}
					value={data && data[column.key] ? data[column.key] : 0}
					placeholder={column?.placeholder ? column?.placeholder : ""}
				/>
			) : (
				<TextField
					variant={variant ? variant : "standard"}
					sx={fieldSx}
					size="small"
					type={datatypes[column?.data_type] ? datatypes[column?.data_type].htmlVar : "text"}
					value={data && data[column.key] ? data[column.key] : ""}
					onChange={onChange}
					disabled={disabled}
					placeholder={column?.placeholder ? column?.placeholder : `Enter ${column?.name ?? column?.key}`}
					required={required ? required : false}
					fullWidth
				/>
			)}
		</Stack>
	);
};

export default CustomTextField;
